import styled from 'styled-components';
import { LockIcon } from '../../../../assets/svg';
import { Text } from '../../../../components';
import { COLORS } from '../../../../constants';
import { useTranslation } from 'react-i18next';
import { MotionPrivateDistribution } from '../../../../components/Motion';

interface PrivateDistributionProps {
  privateReason?: string | undefined | null;
}

export const PrivateDistribution = ({ privateReason }: PrivateDistributionProps) => {
  const { t } = useTranslation();
  return (
    <PrivateDistributionContainer>
      <LockIcon />
      <PrivateDistributionContent>
        <Text
          text={t('screen.project.privateDistributionTitle')}
          weight={700}
          lineHeight={20}
        />
        <Text
          text={privateReason || t('screen.project.privateDistributionText')}
          weight={600}
          size={12}
          lineHeight={14}
          color={COLORS.INDUSTRY_INACTIVE_TEXT}
        />
      </PrivateDistributionContent>
    </PrivateDistributionContainer>
  );
};

const PrivateDistributionContainer = styled(MotionPrivateDistribution)`
  display: flex;
  align-items: flex-end;
  gap: 18px;
`;

const PrivateDistributionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
